import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shujuguolv",
  "use": "icon-shujuguolv-usage",
  "viewBox": "0 0 1075 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1075 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shujuguolv\"><path d=\"M1075.473 7.11111111L659.01 382.24011111V1031.11111111L416.463 797.14311111V382.24011111L0 7.11111111h1075.473z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol